import { NgModule } from "@angular/core";
import { CreateReminderFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/reminder/create-reminder/create-reminder-function.service";

@NgModule({
  imports: [],
  declarations: [],
  providers: [CreateReminderFunctionService]
})
export class CreateReminderFunctionModule {}
